import { useState, useEffect } from 'react';

export const useLocalStorage = (key, initialValue = null) => {
  const [value, setValue] = useState(() => {
    try {
      const item = localStorage.getItem(key);
      return item || initialValue;
    } catch (error) {
      console.error(`Error when reading localStorage for the key "${key}":`, error);
      return initialValue;
    }
  });

  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === key) {
        setValue(e.newValue);
      }
    };

    const handleCustomStorageChange = (e) => {
      if (e.detail.key === key) {
        setValue(e.detail.newValue);
      }
    };

    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('customStorageChange', handleCustomStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('customStorageChange', handleCustomStorageChange);
    };
  }, [key]);

  const setStoredValue = (newValue) => {
    try {
      if (newValue === null) {
        localStorage.removeItem(key);
      } else {
        localStorage.setItem(key, newValue);
      }

      setValue(newValue);

      window.dispatchEvent(new CustomEvent('customStorageChange', {
        detail: { key, newValue }
      }));
    } catch (error) {
      console.error(`Error while writing localStorage for the key "${key}":`, error);
    }
  };

  return [value, setStoredValue];
};
